export default function TableHeaderArrowUpIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M9 3L6 6.09677H8.25V15H9.75V6.09677H12L9 3Z" fill="currentColor" />
    </svg>
  );
}
